import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetUserPortfoliosRequest extends BaseServiceRequest {
    constructor(endDate) {
        super();
        super.addRequestUri("getportfoliominilist/");
        super.setContent({
            "listId": 1,
            "reportType": 1,
            "endDate": endDate,
            "refreshCache": false
        });
    }

    getMethod() {
        return HttpMethodType.POST;
    }

    getSubSystem() {
        return SubSystemType.ACCOUNT_ANALYZER;
    }

    // getMessageName() {
    //   return "UserPortfoliosResponseData";
    // }
}

export default GetUserPortfoliosRequest;
